"use strict";

let instance = null;
import Api from "../Api";
/**
 * Logger Tracker
 * It is our own tracking logic
 */
export class Tracker {
  /**
   * Constructor of EventBus.
   * @return {*}
   */
  constructor() {
    // Make this a singleton.
    if (instance) return instance;
    else instance = this;
  }

  /**
   * gamePlay
   * Tracks user activity on a game
   * so that we can show users the playing users on friends invite
   */
  gamePlay() {
    Api.trackPlayingUser();
  }
}
